import { useQuery } from '@apollo/client';

import { queryParams } from 'app/shared/utils/queries';
import {
  GetSurveyQuestionsData,
  GetSurveyQuestionsVariables,
} from 'app/shared/typings/surveyQuestions';

import { GET_SURVEY_QUESTIONS } from './queries';

export const GetSurveyQuestions = (
  params: GetSurveyQuestionsVariables = {}
) => {
  return useQuery<GetSurveyQuestionsData>(
    GET_SURVEY_QUESTIONS,
    queryParams(params)
  );
};
